<template>
  <div>
  <dl v-if="!json.init" class="spe-picture-carousel" :style="commonStyle" :ddt-area="`component_${json.floorId}_图片轮播组件`" ddt-expose="on">
		<!-- 新人专区规则入口 -->
		<div v-if="ruleInfo.name" class="rule-info" @click="$sys.dict.href(ruleInfo.jumpLink)">{{ruleInfo.name}}</div>
		<!-- 标题背景(1文案标题，2标题图) -->
		<dt
      v-if="jdata.header.type == 1"
      :style="{ backgroundColor: jdata.header.backgroundColor || jdata.header.backgroundDefaultColor }"
      @click="$sys.dict.href_for_type(jdata.header.jumpContent, jdata.header.jumpType)"
      :data-area="pt()"
      :data-pos="`component_${json.floorId}_图片轮播组件.标题_点击跳转`"
      :data-desc="jdata.header.title"
      :dd_name="`${pt()}.component_${json.floorId}_图片轮播组件.标题_点击跳转.${jdata.header.title}`"
      :ddt-click="`${pt()}.component_${json.floorId}_图片轮播组件.标题_点击跳转.${jdata.header.title}`"
      ddt-pit="标题_点击跳转"
      :ddt-src="jdata.header.title"
      ddt-expose="on"
    >
			<label :style="{ color: jdata.header.titleColor || jdata.header.titleDefaultColor }">{{ jdata.header.title }}</label>
			<span :style="{ color: jdata.header.moreTextColor || jdata.header.moreTextDefaultColor }" v-if="jdata.header.jumpType > 0">{{ jdata.header.moreText }}<i class="iconfont">&#xe669;</i></span>
		</dt>
		<dt style="padding:0;" v-if="jdata.header.type == 2">
			<img v-lazy="jdata.header.backgroundImage" />
		</dt>
		<dd :style="ddStyle">
			<swiper ref="mySwiper" :options="swiperOptions" v-if="jdata.imageData.length > 0">
				<swiper-slide v-for="(el, index) in jdata.imageData" :key="index">
					<a
            :data-area="pt()"
            :data-pos="`component_${json.floorId}_图片轮播组件.坑位${index + 1}_点击跳转`"
            :data-desc="el.image"
            :dd_name="`${pt()}.component_${json.floorId}_图片轮播组件.坑位${index + 1}_点击跳转.${el.image}`"
            :ddt-click="`${pt()}.component_${json.floorId}_图片轮播组件.坑位${index + 1}_点击跳转.${el.image}`"
            :ddt-pit="`坑位${index + 1}_点击跳转`"
            :ddt-src="el.image"
            ddt-expose="on"
            @click="$sys.dict.href(el.jumpUrl)"
          >
						<img v-lazy="el.image" />
					</a>
				</swiper-slide>
				<div v-if="jdata.imageData.length > 1" class="swiper-pagination" slot="pagination"></div>
			</swiper>
		</dd>
	</dl>
  <div v-else :style="{height:`${json.height}px`}"></div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
// import style (>= Swiper 6.x)
import "swiper/css/swiper.css";

export default {
	props: {
		json: {
			type: Object,
			default: () => {
				return {};
			}
		},
		ruleInfo: {
			type: Object,
			default: () => {
				return {
					name: '',
					jumpLink: ''
				}
			}
		}
	},
	components: {
		Swiper,
		SwiperSlide
	},
	data() {
		return {};
	},
  inject: ['pt'],
	computed: {
		jdata() {
			return this.json.data || { commonStyle: {}, imageData: [], info: {}, header: {} };
		},
		swiper() {
			return this.$refs.mySwiper.$swiper;
		},
		commonStyle() {
      let sty = {}
      if (this.jdata.commonStyle.backgroundType == 2) {
        //背景图
        sty.backgroundImage = `url(${this.jdata.commonStyle.backgroundImage})`;
      } else if(this.jdata.commonStyle.backgroundType == 1){
        if (this.jdata.commonStyle.usePageBackgroundColor) {
          sty.backgroundColor =this.jdata.commonStyle.bgColor
        }else{
          sty.backgroundColor = this.jdata.commonStyle.backgroundColor;
        }
      }
			return sty;
		},
    ddStyle() {
      if(this.jdata.commonStyle.margin > 0){
        let sty = {
          padding: `0 ${this.jdata.commonStyle.margin}px`
        };
        return sty;
      }
    },
		swiperOptions() {
			let swiperOptions = {
				slidesPerView: 1,
				loop: false,
				autoplay: {
					delay: (this.jdata.info.interval || 1) * 1000,
					stopOnLastSlide: false,
					disableOnInteraction: false
				},
				pagination: {
					el: ".swiper-pagination",
					type: this.jdata.styleType == 1 ? "bullets" : "fraction"
				},
				observer: true, //修改swiper自己或子元素时，自动初始化swiper
				observeParents: true //修改swiper的父元素时，自动初始化swiper
				// Some Swiper option/callback...
			};
			return swiperOptions;
		}
	},
	watch: {},
	mounted() {
		window.onpageshow = function(event) {
			// console.log('page show')
			// console.log(this.swiper.slideNext);
			if (event.persisted) {
				if (this.swiper) {
					this.swiper.animating = false;
					this.swiper.slideNext();
				}
			}
		}.bind(this);
	},
	methods: {},
	filters: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.spe-picture-carousel {
	min-height: 222px;
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
	position: relative;

	.rule-info {
		width: 70px;
		height: 50px;
		position: absolute;
		top: 10px;
		right: 18px;
		font-size: 24px;
		color: #FFFFFF;
		text-align: right;
		z-index: 999;
	}

	> dt {
		height: 84px;
		padding: 0 40px;
		display: flex;
		align-items: center;
		label {
			flex: 1;
			font-size: 34px;
		}
		span {
			font-size: 24px;
		}
		img {
			width: 100%;
			height: 100%;
		}
	}
	.swiper-container {
		img {
			height: 222px;
			width: 100%;
		}

		.swiper-pagination {
			left: auto;
			right: 20px;
			bottom: 4px;
			width: auto;
			/deep/.swiper-pagination-bullet-active {
				background: #ffffff;
				border: 1px solid rgba(0, 0, 0, 0.17);
			}
		}
		.swiper-pagination-fraction {
			font-size: 20px;
			color: #ffffff;
			border-radius: 12px;
			padding: 2px 12px;
			background: rgba(1, 1, 1, 0.2);
		}
	}
}
</style>
